import { AffiliateWithdrawals } from '@core/models/affiliate-withdrawals.model';
import { EntityCollectionServiceBase, EntityCollectionServiceElementsFactory } from '@ngrx/data';
import { Injectable } from '@angular/core';

@Injectable()
export class AffiliateWithdrawalEntityService extends EntityCollectionServiceBase<AffiliateWithdrawals> {
  constructor(serviceElementsFactory: EntityCollectionServiceElementsFactory) {
      super('AffiliateWithdrawals', serviceElementsFactory);
  }
}

